import BaseRepository from './BaseRepository';

export default class HotelsRepository extends BaseRepository
{
    getEndpoint()
    {
        return 'v1/hotels';
    }

    search(criteria)
    {
        return this.request('GET', `${this.getEndpoint()}/search/${criteria}`, null);
    }
}
